import { Access, Policy } from "../../../../../services/fakeDb";
import { getPlatformSidebar } from "../../../../../services/fakeDb/sidebars";
import PreAnalyticalSetup from "./index";

const diagnostics = [
  "diagnostic",
  "clinic",
  "laboratory",
  "radiology",
  "pharmacy",
  "infirmary",
  "hospital",
  "rehabilitation",
];

/**
 * Finds the route of the pre-analytical setup page on the sidebar of the user,
 * built the same way as the sidebar links (components/sidebar).
 * Returns null when the user has no access to it (e.g., not Chief MLS).
 */
const getSetupPath = (activePlatform = {}, branches = []) => {
  const platformKey = Access.normalizePlatformKey(activePlatform?.platform);
  if (!platformKey) return null;

  const isDiagnostics = diagnostics.includes(
    activePlatform?.branch?.category?.toLowerCase(),
  );
  const sidebar = getPlatformSidebar(platformKey, {
    isDiagnostics,
    activePlatform,
    branches,
  });

  // same access filter as the sidebar, other platforms are not filtered
  const isFiltered = ["laboratory", "frontdesk"].includes(platformKey);
  const access =
    platformKey === "laboratory"
      ? activePlatform?.role
      : platformKey === "frontdesk"
        ? Policy.getDepartment(activePlatform?.position)
        : undefined;
  const isAllowed = ({ allowedFor }) =>
    !isFiltered || !allowedFor || allowedFor.includes(access);

  const find = (items = [], basePath) => {
    for (const item of items) {
      if (!isAllowed(item)) continue;
      const fullPath = Access.normalizePlatformKey(
        `${basePath}${item.path || ""}`,
      );
      if (item.component === PreAnalyticalSetup) return fullPath;
      if (item.children?.length) {
        const found = find(item.children, fullPath);
        if (found) return found;
      }
    }
    return null;
  };

  return find(sidebar, `/${platformKey}`);
};

export default getSetupPath;
